import { createRouter, createWebHistory } from 'vue-router'
import CustOperationView from '../views/CustOperationView.vue'
import InBill from '../views/InBill.vue'
import store from '../store'
import { byVariant } from './templateSwitch'
import { BANK_RECEIPTS_ON } from '../helpers/features.js'

// Order Hist has four versions, picked in the user menu: the original page (lightly
// polished via .oh-classic), the redesign, a hidden experimental copy of it, and Experimental 2 (the redesign with the Note LLM).
const OrderHistView = byVariant('OrderHistView', 'orderHist', {
  old: () => import('../views/OrderHistView.vue'),
  new: () => import('../views/OrderHistV2View.vue'),
  exp: () => import('../views/OrderHistExpView.vue'),
  exp2: () => import('../views/OrderHistExp2View.vue'),   // Experimental 2: the new page plus the Note LLM composer
}, 'new', { old: 'oh-classic' })
const CSNoteView = () => import('../views/CSNoteView.vue')
const DataLoad = () => import('../views/DataLoad.vue')
const ControlPage = () => import('../views/ControlPage.vue')
const InShip = () => import('../views/InShip.vue')
const SettingsView = () => import('../views/SettingsView.vue')
const ShippingToolView = () => import('../views/ShippingToolView.vue')
const BankReceiptView = () => import('../views/BankReceiptView.vue')
const ScheduledJobsView = () => import('../views/ScheduledJobsView.vue')
const NoteLlmView = () => import('../views/NoteLlmView.vue')
const LoginView = () => import('../views/LoginView.vue')

const routes = [
  {
    // no Home page any more: / (also where login and the role checks send people) opens Order Hist
    path: '/',
    name: 'home',
    redirect: '/orderhistory',
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/csnote',
    name: 'CSNoteView',
    component: CSNoteView,
    meta: { requiresAuth: true }
  },
  {
    path: '/custoperation',
    name: 'CustOperationView',
    component: CustOperationView,
    meta: { requiresAuth: true ,
      requiresPlaning: true
    }
  }
  ,
  {
    path: '/orderhistory',
    name: 'OrderHistView',
    component: OrderHistView,
    meta: { requiresAuth: true }
  },
  {
    // the redesign now lives at /orderhistory; keep old links working
    path: '/orderhistory2',
    redirect: to => ({ path: '/orderhistory', query: to.query })
  },
  {
    path: '/dataload',
    name: 'DataLoad',
    component: DataLoad,
    meta: { 
      requiresAuth: true ,
      requiresPlaning: true
    
    }
  }
  ,
  {
    path: '/controlpage',
    name: 'ControlPage',
    component: ControlPage,
    meta: { 
      requiresAuth: true ,
      requiresPlaning: true
    
    }
  },
  {
    path: '/inbill',
    name: 'InBill',
    component: InBill,
    meta: { 
      requiresAuth: true ,
    }
  },
  {
    path: '/inship',
    name: 'InShip',
    component: InShip,
    meta: {
      requiresAuth: true ,
    }
  },
  {
    path: '/settings',
    name: 'SettingsView',
    component: SettingsView,
    meta: {
      requiresAuth: true,
      requiresPlaning: true
    }
  },
  {
    path: '/shippingtool',
    name: 'ShippingToolView',
    component: ShippingToolView,
    meta: {
      requiresAuth: true,
      requiresPlaning: true
    }
  },
  {
    // the server's cron jobs (fitfoodCS/cron); Planning and CashAccountant only
    path: '/scheduledjobs',
    name: 'ScheduledJobsView',
    component: ScheduledJobsView,
    meta: { requiresAuth: true }
  },
  {
    // Settings > Note LLM: how DeepSeek standardises CS notes (_docs/plan_note_llm.md); Planning only
    path: '/notellm',
    name: 'NoteLlmView',
    component: NoteLlmView,
    meta: { requiresAuth: true }
  },
  // Fitfood only: the Ann build has no /bankreceipt (BANK_RECEIPTS_ON in helpers/features.js)
  ...(BANK_RECEIPTS_ON ? [{
    path: '/bankreceipt',
    name: 'BankReceiptView',
    component: BankReceiptView,
    meta: { requiresAuth: true }
  }] : [])
]

const router = createRouter({
  currentURL: '',
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // console.log('router.beforeEach')
  // console.log(store)
  
  if ((to.matched.some(record => record.meta.requiresAuth)) && !(store.getters.isAuthenticated) ) {
    next({name: 'login', query: { to: to.path }})
    
  } else {
    next()
    
  }

})

export default router
